import { i18next } from '@yola/ws-sdk';
import dialogs from 'yola-editor/src/js/modules/dialogs';

function showThankYouDialog({ selectedScore }) {
  const closeDialog = () => dialogs.operations.hide();
  const dialogType = dialogs.dialogTypes.SURVEY_THANK_YOU;
  const isDetractor = selectedScore < 7;
  let thankYouDialogData;

  if (isDetractor) {
    thankYouDialogData = {
      emoji: '&#x1f914;',
      captions: {
        emojiLabel: i18next.t('Thinking Face'),
        content: i18next.t(
          'We appreciate your feedback. We will use it to improve our product in future.'
        ),
        mainAction: i18next.t('Dismiss'),
      },
      onMainAction: closeDialog,
      onClose: closeDialog,
    };
  } else {
    thankYouDialogData = {
      captions: {
        content: i18next.t('Thank you for such encouraging feedback. We appreciate it a lot!'),
        mainAction: i18next.t('Close'),
      },
      onMainAction: closeDialog,
      onClose: closeDialog,
    };
  }

  dialogs.operations.show(dialogType, thankYouDialogData);
}

export default showThankYouDialog;
